import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EcdStates } from '../../root/ecd-model';
import { getEcdEpiProps } from '../ducks/epi-api';
import { EcdRootPage } from '../models/ecd-page-models';


export function useEpiEcdRootPageContent(ecdRootPageContentId?: string) : EcdRootPage {

    const language = useSelector<EcdStates, string>(state => state.globalization?.currentlanguage);
    const pageData = useSelector<EcdStates, any>(state => state.epiProps?.contentState?.epiContent) as EcdRootPage;
    const contentLoaded = useSelector<EcdStates, boolean>(state => state.epiProps?.contentState?.contentLoaded);    

    const dispatch = useDispatch();

    useEffect(() => {
        if (!contentLoaded){
            dispatch(getEcdEpiProps(dispatch, ecdRootPageContentId, {}, language, false));
        }
    }, [contentLoaded]);

    return pageData;
}